import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { installPreloadErrorRecovery } from "./appVersion";
import "./styles/globals.css";

if (import.meta.env.PROD) installPreloadErrorRecovery();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
